define([
    "./trackingLGPDModule",
    "./trackingLgpdApi",
    "./trackingLGPDConfiguration",
], function () {
});